import React from "react";
import { Icon, Typography } from "@mui/material";
import { useField } from "formik";

import RRDDirectMailToolTips from "../RRDDirectMailToolTips";
import RpNumberField from "@/components/muiCustom/textField/RpNumberField";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

const NumberField = RpNumberField as React.ElementType;

function RRDDirectDistributionQntInput({ name, distributionToggleName }) {
  const [field] = useField(name);
  const [distribution] = useField(distributionToggleName);

  return (
    <>
      <Typography variant="body2" gutterBottom fontWeight={600}>
        Expected Distribution{" "}
        <RRDDirectMailToolTips type="estimated_distribution" />
      </Typography>

      <NumberField
        fullWidth
        placeholder="0"
        size="small"
        value={!distribution?.value ? 0 : field?.value}
        defaultValue={field.value}
        sx={{
          "& .MuiOutlinedInput-root": {
            opacity: 0.6,
            pointerEvents: "none",
          },
        }}
        slotProps={{
          input: {
            startAdornment: (
              <Icon
                component={RpSvgIcon}
                name="sheltr"
                color="primary"
                className="mr-2 mb-1"
              />
            ),
            readOnly: true,
          },
        }}
      />
    </>
  );
}

export default RRDDirectDistributionQntInput;
